import { render, staticRenderFns } from "./MarginSummaryRow.vue?vue&type=template&id=722accfa&"
import script from "./MarginSummaryRow.vue?vue&type=script&lang=js&"
export * from "./MarginSummaryRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports